import { render, staticRenderFns } from "./LocaleProviderx.vue?vue&type=template&id=6fb02328&scoped=true&"
import script from "./LocaleProviderx.vue?vue&type=script&lang=js&"
export * from "./LocaleProviderx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb02328",
  null
  
)

export default component.exports